import { PARTNERS_IDS } from 'constants/partners';

import type { FormStepId } from 'shared/config/formStepId';

type EsiaTextsConfigValue = { title: string; titleMobile?: string; subtitle?: string; buttonTitle?: string };

export const EsiaTextsConfig: Record<number | 'default' | 'error', EsiaTextsConfigValue> &
  Partial<Record<ValuesOf<typeof FormStepId>, EsiaTextsConfigValue>> = {
  error: {
    title: 'Что-то пошло не так :(',
    subtitle: 'Мы не смогли заполнить анкету с помощью Госуслуг. Пожалуйста, введите данные вручную',
    buttonTitle: 'Данные из Госуслуг не подтянулись. Попробуйте еще раз или заполните данные вручную',
  },
  default: {
    title: 'Автоматически заполним\u00A0часть\u00A0данных для\u00A0оформления\u00A0кредита',
    titleMobile: 'Автоматически заполним\u00A0часть\u00A0данных для\u00A0оформления\u00A0кредита',
    buttonTitle: 'Войти через Госуслуги',
  },
  passportInfo: {
    title:
      'Заполним анкету данными из Госуслуг — их\u00A0увидят\u00A0только\u00A0банки,\u00A0и\u00A0с\u00A0ними шанс одобрения выше',
    titleMobile: 'Заполним анкету данными из\u00A0Госуслуг – их увидят только банки с ними выше шанс одобрения',
    buttonTitle: 'Войти в Госуслуги',
  },
  [PARTNERS_IDS.avito]: {
    title: 'Войдите через Госуслуги',
    subtitle: 'Данные подгрузятся сами',
  },
};
